import { base } from './';
import { ICollection, SearchCollectionsQueryType } from 'types';

const PATH = '/collection';

const get = (id: string) => base.get(`${PATH}/${id}`);

const getAll = (filter: SearchCollectionsQueryType) =>
  base.get(PATH, { params: { ...filter } });

const post = (data: Partial<ICollection>) => base.post(PATH, data);

const patch = ({ id, ...data }: Partial<ICollection>) =>
  base.patch(`${PATH}/${id}`, data);

export { get, getAll, post, patch };
